/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum LogSortDirection {
  'asc' = '+',
  'desc' = '-',
}
